'use client'
import getHospitalLink from '@/utils/hospital/getHospitalLink'
import { useLocale, useTranslations } from 'next-intl'
import Image from 'next/image'
import { useParams, useSearchParams } from 'next/navigation'
import DynamicLink from './DynamicLink'

const EmptyState = ({
  link = '/contact',
  icon = 'comment-alt-smile',
  linkLabel = 'contact-us',
  addedClass = '',
}) => {
  const __t = useTranslations()
  const locale = useLocale()
  const { hospital } = useParams()
  const searchParams = useSearchParams()
  const paged = searchParams.get('paged')
  // handle redirect if paged is not 1 and empty so it will redirect to the first page
  if (paged && paged !== '1') {
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(searchParams)
      params.set('paged', '1')
      const newUrl = `${window.location.pathname}${
        params.toString() ? '?' + params.toString() : ''
      }`
      window.location.replace(newUrl)
    }
  }

  return (
    <div
      className={`tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-min-h-[40vh] ${addedClass}`}
    >
      <Image
        alt="Not found"
        src="https://static.bangkokhospital.com/uploads/assets/images/empty.svg"
        width={68}
        height={68}
        className="tw-animate-wiggle"
      />
      <h5 className="tw-text-bgh-blue tw-mt-8 tw-mb-2 max-sm:tw-text-center">
        {__t('sorry-we-couldnt-find-any-article-related-to-your-search')}
      </h5>
      <div className="tw-text-primary tw-flex tw-flex-wrap max-sm:tw-justify-center max-sm:tw-text-center">
        <span>
          {__t('if-you-are-having-trouble-searching-through-our-website')}
        </span>
        <DynamicLink
          isLinkTag={getHospitalLink(hospital) === hospital}
          locale={locale}
          prefetch={false}
          href={getHospitalLink(hospital || 'bangkok', link)}
          className="tw-inline-flex tw-items-center tw-space-x-2 tw-mx-2"
        >
          <i className={`fas fa-${icon} tw-text-bgh-red`} />
          <p className="tw-font-bold tw-text-bgh-red">{__t(linkLabel)}</p>
        </DynamicLink>
        <span>{__t('instead')}.</span>
      </div>
    </div>
  )
}

export default EmptyState
